/** Convert a name string to a URL-safe kebab-case slug. */
export function toSlug(name: string): string {
	return name
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');
}

/** Format an ISO timestamp as a human-readable relative time string. */
export function formatRelativeTime(iso: string): string {
	const diffMs = Date.now() - Date.parse(iso);
	const diffSec = Math.floor(diffMs / 1000);

	if (diffSec < 60) return 'just now';

	const diffMin = Math.floor(diffSec / 60);
	if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? '' : 's'} ago`;

	const diffHr = Math.floor(diffMin / 60);
	if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? '' : 's'} ago`;

	const diffDay = Math.floor(diffHr / 24);
	if (diffDay < 30) return `${diffDay} day${diffDay === 1 ? '' : 's'} ago`;

	const diffMonth = Math.floor(diffDay / 30);
	if (diffMonth < 12) return `${diffMonth} month${diffMonth === 1 ? '' : 's'} ago`;

	const diffYear = Math.floor(diffMonth / 12);
	return `${diffYear} year${diffYear === 1 ? '' : 's'} ago`;
}
